import script from "./AdminManageVehiclesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManageVehiclesView.vue?vue&type=script&setup=true&lang=js"

import "./AdminManageVehiclesView.vue?vue&type=style&index=0&id=5ff134e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff134e8"]])

export default __exports__